const Emitter = require('client/lib/emitter')
const airbrake = require('client/lib/airbrake')

module.exports = class BaseAutocomplete extends Emitter{
  constructor(target) {
    super()
    this.$target = $(target)
    this.$collection = $('<ul/>')
      .addClass('collection autocomplete supercomplete baseautocomplete')
      .attr('data-click', 'stop-propagation')
      .insertAfter(target)
    this.el = this.$target.get(0)
    this.$target.on('keydown', this._keydown.bind(this))
    this.$target.on('keyup', this._keyup.bind(this))
    this.$collection.on('click', '.collection-item', this._click.bind(this))
    $(document).on('click', (e) => {
      if (e.isImmediatePropagationStopped()) {
        return
      }
      this.trigger('hide')
    })
    app.on('navigationend', () => {
      this.trigger('hide')
    })
  }

  '_click'(e) {
    e.preventDefault()
    e.keyCode = 13
    $(e.currentTarget).addClass('active')
    this.$target.focus()
    this._keydown(e)
  }

  '_keyup'(e) {
    switch (e.keyCode) {
      case 9 :
      case 13:
      case 38:
      case 40:
        return
      case 27:
        return this.trigger('hide')
    }
    this.$collection.empty()
    if (!this.el.value) {
      return
    }
    this.getResults(this.el.value)
    .then(suggestions => {
      suggestions.forEach(option => {
        $('<li/>')
        .addClass('collection-item')
        .attr('data-complete', option.complete)
        .html(option.name)
        .appendTo(this.$collection)
      })
    })
    .catch(err => airbrake.notify(err))
    this.$collection.addClass('active')
  }

  /* eslint-disable complexity */
  '_keydown'(e) {
    if (!this.el.value) {
      return this.trigger('hide')
    }
    const $prev = this.$selected.prev()
    const $next = this.$selected.next()
    const $active = this.$collection.find('.active')

    switch (e.keyCode) {
      case 38: // up
        e.preventDefault()
        if (this.el.value) {
          e.stopPropagation()
        }
        this.$selected = this.$collection.find('.active')
        if (!this.$selected.length) {
          return
        }
        if ($prev.length) {
          this.$selected.removeClass('active')
          $prev.addClass('active')
        }
      break
      case 40: // down
        e.preventDefault()
        this.$selected = this.$collection.find('.active')
        if (this.el.value) {
          e.stopPropagation()
        }
        if (!this.$selected.length) {
          this.$selected = this.$collection.find('.collection-item').first()
          if (this.$selected.length) {
            this.$selected.addClass('active')
          }
          return
        }
        if ($next.length) {
          this.$selected.removeClass('active')
          $next.addClass('active')
        }
      break
      case 13: // enter
      case 9: // tab
        if (!$active.length) {
          return
        }
        e.preventDefault()
        this.el.value = $active.attr('data-complete')
        this.trigger('hide')
        this.trigger('insert', this.el.value)
      break
      case 27: // escape
        this.trigger('hide')
      break
    }
  }
  /* eslint-enable complexity */
}
